import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2338">
      <Navbar data-id="element-2339" />
      <main data-id="element-2340">
        <ConsularAffairs data-id="element-2341" />
      </main>
      <Footer data-id="element-2342" />
      <FeedbackPopup data-id="element-2343" />
    </div>;
}